import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import InputText from '../../components/input/inputText';
import InputNumber from '../../components/input/inputNumber';
import InputEmail from '../../components/input/inputEmail';
import InputDate from '../../components/input/inputDate';
import InputGender from '../../components/input/inputGender';
import InputCheckbox from '../../components/input/inputCheckbox';
import InputPassword from '../../components/input/inputPassword';
import InputSelect from '../../components/input/inputSelect';
import ButtonLarge from '../../components/buttonLarge';
import iconScan from '../../assets/icon/icon_scan.svg';
import { ProfileContext } from '../../components/context/profileContext';
import iconClose from '../../assets/icon/icon_close.svg';
import parse from 'html-react-parser';

const FormBuatProfile = (props) => {
  const { profile } = useContext(ProfileContext);
  const [defGender, setDefGender] = useState('');
  const [showPrivacy, setShowPrivacy] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    const savedData = localStorage.getItem('biodata');
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      Object.keys(parsedData).forEach((key) => {
        setValue(key, parsedData[key]);
      });

      setDefGender(parsedData['gender']);
    }
  }, [setValue]);

  const checkCanSubmit = () => {
    if (props?.credit <= 0 && !profile) {
      return false;
    } else {
      return true;
    }
  };

  const onSubmit = (data) => {
    if (!checkCanSubmit()) {
      return;
    }

    const payload = {
      ...data
    };

    localStorage.setItem('biodata', JSON.stringify(payload));

    props.onSubmitForm(payload);
  };

  const strHtml = `

    <p>
        Kalbe Consumer Health (selanjutnya disebut "Kalbe", "kami") berkomitmen untuk melindungi privasi dan keamanan informasi pribadi Anda.
        Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi yang Anda berikan saat menggunakan layanan Kalpanax Skin Check.
        Dengan menggunakan layanan kami, Anda setuju untuk terikat dengan kebijakan ini.
    </p>
    <br/>

    <h2>1. Informasi yang Kami Kumpulkan</h2>
    <p>Kami mengumpulkan informasi berikut:</p>
    <ul>
        <li><strong>Informasi Pribadi:</strong> Nama, alamat email, nomor telepon, dan informasi lain yang Anda berikan saat mendaftar atau menggunakan layanan kami.</li>
        <li><strong>Informasi Kesehatan:</strong> Data yang berkaitan dengan kondisi kulit Anda dan informasi kesehatan lain yang Anda berikan selama pemeriksaan kulit.</li>
        <li><strong>Informasi Penggunaan:</strong> Data tentang bagaimana Anda mengakses dan menggunakan situs web atau aplikasi kami, termasuk alamat IP, jenis perangkat, dan aktivitas browsing.</li>
    </ul>

    <br/>

    <h2>2. Penggunaan Informasi</h2>
    <p>Informasi yang kami kumpulkan digunakan untuk:</p>
    <ul>
        <li>Menyediakan, memelihara, dan meningkatkan layanan kami.</li>
        <li>Menghubungi Anda mengenai layanan, promosi, dan informasi penting lainnya.</li>
        <li>Memproses permintaan Anda dan memberikan dukungan pelanggan.</li>
        <li>Menganalisis penggunaan layanan untuk memahami cara kami dapat meningkatkan pengalaman pengguna.</li>
    </ul>

     <br/>
    <h2>3. Perlindungan Informasi</h2>
    <p>
        Kami mengambil langkah-langkah keamanan yang sesuai untuk melindungi informasi pribadi Anda dari akses yang tidak sah, pengungkapan, atau penggunaan.
        Hanya karyawan yang membutuhkan akses untuk melakukan tugas mereka yang akan diberikan akses ke informasi pribadi Anda.
    </p>

     <br/>
    <h2>4. Berbagi Informasi</h2>
    <p>Kami tidak akan menjual, menyewakan, atau membagikan informasi pribadi Anda dengan pihak ketiga tanpa persetujuan Anda, kecuali dalam kondisi berikut:</p>
    <ul>
        <li>Untuk memenuhi hukum dan peraturan yang berlaku.</li>
        <li>Untuk melindungi hak, privasi, atau keselamatan Anda atau orang lain.</li>
        <li>Dalam hal kami menggabungkan atau menjual sebagian atau seluruh bisnis kami.</li>
    </ul>

     <br/>
    <h2>5. Hak Anda</h2>
    <p>
        Anda memiliki hak untuk mengakses, memperbaiki, atau menghapus informasi pribadi yang kami miliki tentang Anda.
        Jika Anda ingin menggunakan hak ini, silakan hubungi kami melalui informasi kontak di bawah.
    </p>

     <br/>
    <h2>6. Perubahan Kebijakan Privasi</h2>
    <p>
        Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu.
        Kami akan memberi tahu Anda tentang perubahan melalui situs web kami atau melalui email.
        Penggunaan berkelanjutan dari layanan kami setelah perubahan ini akan dianggap sebagai penerimaan Anda terhadap kebijakan yang diperbarui.
    </p>`;

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="p-6 flex flex-col justify-between w-full px-5 md:px-12 mx-auto">
      {showPrivacy && (
        <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-black bg-opacity-50 p-6">
          <div className="flex flex-col bg-white p-6 rounded-md w-full md:w-1/2 h-full">
            <div className="flex space-x-2 justify-between items-center">
              <div className="w-full  md:text-xl font-semibold text-textBlack">
                Kebijakan Privasi Kalpanax Skin Check
              </div>
              <div className="flex justify-end items-center ">
                <img
                  onClick={() => setShowPrivacy(!showPrivacy)}
                  src={iconClose}
                  className="cursor-pointer w-8 h-8 object-contain"
                  alt="icon_close"
                />
              </div>
            </div>
            <hr className="mt-4" />
            <div className="max-h-full overflow-auto py-5">
              {' '}
              {parse(strHtml ?? '')}
            </div>
          </div>
        </div>
      )}

      <div className="grid xl:grid-cols-2 gap-y-5 gap-x-10">
        <div>
          <InputText
            label="Nama *"
            register={register}
            errors={errors}
            placeholder={'Masukkan nama anda'}
            validation={{
              name: 'name',
              rules: { required: 'Nama harus diisi' }
            }}
          />
          <InputNumber
            label="No Telpon *"
            register={register}
            errors={errors}
            placeholder={'Masukkan no telpon anda'}
            validation={{
              name: 'phone',
              rules: {
                required: 'Phone number harus diisi',
                minLength: { value: 10, message: 'Minimum 10 digits' },
                maxLength: { value: 15, message: 'Maximum 15 digits' }
              }
            }}
          />
          <InputEmail
            label="Email"
            register={register}
            errors={errors}
            placeholder={'Masukkan email anda'}
            validation={{
              name: 'email',
              rules: {
                // required: 'Email harus diisi',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Enter a valid email address'
                }
              }
            }}
          />
        </div>

        <div>
          <InputGender
            label="Jenis Kelamin"
            register={register}
            errors={errors}
            validation={{ name: 'gender' }}
            setValue={setValue}
            defGender={defGender}
          />

          <InputDate
            label="Tanggal Lahir"
            register={register}
            errors={errors}
            validation={{
              name: 'date',
              rules: { required: 'Tanggal harus diisi' }
            }}
          />

          {!profile && (
            <InputText
              label="Referral"
              register={register}
              errors={errors}
              placeholder={'Masukkan referral'}
              validation={{
                name: 'referral_code',
                rules: { required: false }
              }}
            />
          )}

          {profile && (
            <InputText
              label="Event"
              register={register}
              errors={errors}
              placeholder={'Masukkan event'}
              validation={{
                name: 'event',
                rules: { required: 'Event harus diisi' }
              }}
            />
          )}
        </div>
      </div>
      <div className="text-sm font-semibold text-red text-left">(*) Wajib Diisi</div>
      <br />

      <div>
        <div className="flex justify-center items-start">
          <InputCheckbox
            label=""
            register={register}
            errors={errors}
            validation={{
              name: 'acceptTerms',
              rules: { required: 'You must accept the terms' }
            }}
          />
          <div>
            <div>
              Saya setuju dengan{' '}
              <strong
                onClick={() => setShowPrivacy(true)}
                className="cursor-pointer">
                <u className="text-red">kebijakan privasi</u>
              </strong>{' '}
              dan penggunaan data saya.
            </div>
            {errors['acceptTerms'] && (
              <p className="text-red text-sm">You must accept the terms</p>
            )}
          </div>
        </div>

        <div className="flex flex-col justify-start items-center">
          <span className="text-red text-sm my-4 text-center">
            {props?.credit <= 0 &&
              !profile &&
              'Kuota Anda sudah habis, silahkan lakukan pemeriksaan lagi dalam 24 jam ke depan'}
          </span>
          <div className="w-full md:max-w-[250px] px-10 md:px-0">
            <ButtonLarge
              type={checkCanSubmit() ? 'submit' : 'button'}
              disabled={!checkCanSubmit()}
              onClick={() => {}}
              label="Selanjutnya"
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default FormBuatProfile;
